window.addEventListener("load", () => {
  /* Validador rut new */
  function validarRUT(rut) {
    // Quitar puntos y convertir a mayúsculas
    rut = rut.replace(/\./g, "").toUpperCase();

    // Validar formato
    const rutRegex = /^[0-9]+-[0-9K]$/;
    if (!rutRegex.test(rut)) {
      return false;
    }

    // Separar cuerpo y dígito verificador
    const [cuerpo, dv] = rut.split("-");

    // Validar cuerpo (longitud mínima y numérico)
    if (cuerpo.length < 7 || isNaN(cuerpo)) {
      return false;
    }

    // Calcular dígito verificador
    let suma = 0;
    let multiplicador = 2;

    for (let i = cuerpo.length - 1; i >= 0; i--) {
      suma += parseInt(cuerpo[i]) * multiplicador;
      multiplicador = multiplicador === 7 ? 2 : multiplicador + 1;
    }

    const resto = suma % 11;
    const dvCalculado =
      resto === 1 ? "K" : resto === 0 ? "0" : (11 - resto).toString();

    // Comparar con el dígito verificador proporcionado
    if (dv === dvCalculado) {
      return rut;
    } else {
      return "";
    }
  }

  /* Format XX.XXX.XXX-X */
  /* -------------------------------------------------------------------------------------- */
  function getFormatRUT(rut) {
    // Letters and numbers 'k'
    const rutClear = rut.replace(/[^0-9kK]/g, "");
    const body = rutClear.slice(0, -1);
    const div = rutClear.slice(-1).toUpperCase();
    if (rutClear.length < 2) return rutClear;
    // dash, and one check number
    let bodyFormatMiles = body
      .toString()
      .split("")
      .reverse()
      .join("")
      .replace(/(?=\d*\.?)(\d{3})/g, "$1.");

    bodyFormatMiles = bodyFormatMiles
      .split("")
      .reverse()
      .join("")
      .replace(/^[\.]/, "");
    return `${bodyFormatMiles}-${div}`;
  }
  /* Create array to send as TAGS  */
  /* -------------------------------------------------------------------------------------- */
  async function createArray(
    validationTags,
    validationInput,
    tagsValue,
    el,
    nameInput
  ) {
    //Format RUT
    if (nameInput == "RUT_") {
      let rutFormat = await getFormatRUT($(el).val());
      $(el).val(rutFormat);
    }
    // Create array
    var inputRutValue = nameInput + $(el).val();
    var arrayTags = validationTags == true ? tagsValue.split(",") : [];
    if (validationInput == true) {
      if (validationTags == true) {
        var i = arrayTags.findIndex((v) => v.includes(nameInput));
        if (i != -1) {
          // Update value
          arrayTags[i] = inputRutValue;
        } else {
          // Create value
          arrayTags.push(inputRutValue);
        }
      } else {
        arrayTags.push(inputRutValue);
      }
    } else {
      if (validationTags == true) {
        var y = arrayTags.findIndex((v) => v.includes(nameInput));
        if (y != -1) {
          if (arrayTags.length == 1) {
            // Delete array
            arrayTags.pop();
          } else {
            // Delete value
            arrayTags.splice(y, 1);
          }
        }
      }
    }
    // Convert array to string
    var result = arrayTags.toString();
    return result;
  }
  /* Inputs */
  /* -------------------------------------------------------------------------------------- */
  $(".form_create_customer").on(
    "keyup",
    "#oldRegisterForm-RUT",
    debounce(function () {
      var inputTagsValue = $("#oldRegisterForm-Tags").val();
      var regex = /[^\s]/;
      var inputTagsCondicion = regex.test(inputTagsValue);
      var inputRutCondicion = regex.test($(this).val());
      createArray(
        inputTagsCondicion,
        inputRutCondicion,
        inputTagsValue,
        this,
        "RUT_"
      )
        .then(function (newValue) {
          $("#oldRegisterForm-Tags").val(newValue);
        })
        .catch((err) => console.log(err));
    }, 500)
  );

  $(".form_create_customer").on(
    "keyup",
    "#oldRegisterForm-phone",
    debounce(function () {
      var inputTagsValue = $("#oldRegisterForm-Tags").val();
      var regex = /[^\s]/;
      var inputTagsCondicion = regex.test(inputTagsValue);
      var inputPhoneCondicion = regex.test($(this).val());
      createArray(
        inputTagsCondicion,
        inputPhoneCondicion,
        inputTagsValue,
        this,
        "PHONE_"
      )
        .then(function (newValue) {
          $("#oldRegisterForm-Tags").val(newValue);
        })
        .catch((err) => console.log(err));
    }, 500)
  );

  $("#oldRegisterForm-legal").change(function () {
    var inputTagsValue = $("#oldRegisterForm-Tags").val();
    var regex = /[^\s]/;
    var inputTagsCondicion = regex.test(inputTagsValue);
    createArray(
      inputTagsCondicion,
      this.checked,
      inputTagsValue,
      this,
      "TERMS_"
    )
      .then(function (newValue) {
        $("#oldRegisterForm-Tags").val(newValue);
      })
      .catch((err) => console.log(err));
  });
});
